import React from 'react';
import classnames from 'classnames';
import { FolderFeed } from 'screens/FolderScreen';
import styles from './FolderScreen.module.scss';
import { VerticalNavigation } from 'components';

export const FolderScreen = () => {
  return (
    <>
      <VerticalNavigation />
      <div className={styles.content}>
        <div className={classnames(styles.contentBin, styles.layoutMain)}>
          <div className={styles.MainColumn}>
            <div className={styles.FeedContainer}>
              <FolderFeed />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FolderScreen;
